export default {
  choices: [
    { id: 'America/Chicago', name: 'America/Chicago' },
  ],
};
